import DisputeCenter from './DisputeCenter';
import {ActionCreators} from '../../actions';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getUser, getClient, getCitation, getDashboard} from '../../reducers/rootReducer';

const mapStateToProps = state => {
  const {user, users, impersonated} = getUser(state);
  const {clients} = getClient(state);
  const {citations} = getCitation(state);
  const {disputes} = getDashboard(state)

  return {
    user,
    users,
    clients,
    disputes,
    citations,
    impersonated,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActionCreators, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DisputeCenter);